import {
  MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_REQUEST,
  MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_SUCCESS,
  MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_FAIL,
  MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_REQUEST,
  MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_SUCCESS,
  MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_FAIL,
  MARKETPLACE_LISTING_SEARCH_QUERY_CHANGE,
  MARKETPLACE_LISTING_SEARCH_QUERY_CLEAR,
  MARKETPLACE_LISTING_SEARCH_ATTR_CHANGE,
  MARKETPLACE_LISTING_SEARCH_RESET,
  MARKETPLACE_LISTING_VIEW_CHANGE,
  MARKETPLACE_LISTING_AVAILABLE_ATTRS_SUCCESS,
  MARKETPLACE_LISTING_SEARCH_RESET_INNER_ATTRS,
} from '../actions/marketplace_listing_search'
import {
  Map as ImmutableMap,
  List as ImmutableList,
  fromJS,
} from 'immutable'
import { 
  MARKETPLACE_LISTING_VIEW_TAB_TYPE_CARD,
} from '../constants'

const initialState = ImmutableMap({
  items: ImmutableList(),
  next: null,
  isLoading: false,
  isError: false,
  isChanged: false,
  view_tab: MARKETPLACE_LISTING_VIEW_TAB_TYPE_CARD,
  current_items_filters: ImmutableMap(),
  filters: ImmutableMap(),
  available_attrs: null,
})

const appendToList = (state, marketplaceListings, next) => {
  return state.update((map) => {
    return map
      .set('next', next)
      .set('isLoading', false)
      .update('items', (list) => {
        // unique
        let n = list.concat(marketplaceListings.map(item => item.id))
        n = Array.from(new Set(n))
        return fromJS(n)
      })
  })
}

export default function marketplace_listing_search(state = initialState, action) {
  switch(action.type) {
    case MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_REQUEST:
      return state.withMutations((map) => {
        map.set('isLoading', true)
        map.set('isError', false)
        map.set('isChanged', false)
      })
    case MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_SUCCESS:
      // console.log("action.currentFilters:", action.currentFilters)
      return state
        .set('items', ImmutableList(action.data.map(item => item.id)))
        .set('next', action.next)
        .set('current_items_filters', action.currentFilters)
        .set('isLoading', false)
        .set('isError', false)
        .set('isChanged', false)
    case MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_REQUEST:
      return state.withMutations((map) => {
        map.set('isLoading', true)
        map.set('isError', false)
        map.set('isChanged', false)
      })
    case MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_SUCCESS:
      return appendToList(state, action.data, action.next)
    
    case MARKETPLACE_LISTINGS_FETCH_BY_SEARCH_FAIL:
    case MARKETPLACE_LISTINGS_EXPAND_BY_SEARCH_FAIL:
      return state
        .set('items', ImmutableList())
        .set('next', null)
        .set('isLoading', false)
        .set('isError', false)
        .set('isChanged', false)

    case MARKETPLACE_LISTING_SEARCH_QUERY_CHANGE:
      return state.withMutations((map) => {
        map.setIn(['filters', 'query'], action.value)
        map.set('isChanged', true)
      })
    case MARKETPLACE_LISTING_SEARCH_QUERY_CLEAR:
      return state.withMutations((map) => {
        map.setIn(['filters', 'query'], '')
        map.set('isChanged', true)
      })
    case MARKETPLACE_LISTING_SEARCH_ATTR_CHANGE:
      const setKey = Array.isArray(action.listing_key) ? ['filters', ...action.listing_key] : ['filters', action.listing_key]
      state = state.setIn(setKey, action.listing_value)
      state = state.set('isChanged', true)
      return state
    case MARKETPLACE_LISTING_VIEW_CHANGE:
      return state.set('view_tab', action.tab)
    case MARKETPLACE_LISTING_SEARCH_RESET:
      return state.withMutations(map => {
        map.setIn(['filters'], ImmutableMap())
        map.set('isChanged', false)
      })
    case MARKETPLACE_LISTING_AVAILABLE_ATTRS_SUCCESS:
      return state.withMutations((map) => {
        map.set('available_attrs', fromJS(action.data))
      })
    case MARKETPLACE_LISTING_SEARCH_RESET_INNER_ATTRS:
      return state.withMutations((map) => {
        map.setIn(['filters', 'attrs'], ImmutableMap({}))
      })
  default:
    return state
  }
}
